import React from "react";
import TapCard from "./TapCard";

import { TRADES as TRADE_NAMES, TRADE_EMOJIS } from "../../../config/tradeOptions";

// Build the picker list from the canonical names + emoji map so this
// component never drifts from the source-of-truth list.
const TRADES = TRADE_NAMES.map((label) => ({ label, emoji: TRADE_EMOJIS[label] || "" }));

export default function StepTrade({ form, update, onNext }) {
  function handleSelect(label) {
    update("trade", label);
    // Bug 1 fix: pass value directly so parent validateStep doesn't rely on stale form state
    setTimeout(() => onNext(label), 150);
  }

  return (
    <div>
      <h2 style={{ margin: "0 0 4px", fontSize: "1.3rem", fontWeight: 700, color: "var(--text, #1C1C1E)" }}>
        What do you need done?
      </h2>
      <p style={{ margin: "0 0 20px", fontSize: "0.9rem", color: "var(--muted, #6b7280)" }}>
        Tap to choose your trade
      </p>
      {/* Bug 2 fix: className matches the CSS rule below */}
      <style>{`
        @media (min-width: 600px) {
          .step-trade-grid {
            grid-template-columns: repeat(4, 1fr) !important;
          }
        }
      `}</style>
      <div
        className="step-trade-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "12px",
        }}
      >
        {TRADES.map((t) => (
          <TapCard
            key={t.label}
            emoji={t.emoji}
            label={t.label}
            selected={form.trade === t.label}
            onSelect={() => handleSelect(t.label)}
          />
        ))}
      </div>
    </div>
  );
}
